var _path, _ellipse, _ellipse2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWsIllustration = function SvgWsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.235 6.424c23.937-4.828 47.821 9.305 54.828 32.53a57.68 57.68 0 0 1 1.296 5.667l.087.378c.194.85.273 1.629.351 2.408 2.857 16.855 13.758 23.078 20.975 25.41 2.252.25 4.453.711 6.581 1.29 16.971 4.846 30.726 18.75 34.225 37.543 4.672 24.791-10.69 49.669-35.046 56.592-7.685 2.17-15.402 2.452-22.614 1.016-17.73-3.365-35.908 2.654-48.31 16.043-8.222 8.981-19.288 15.562-32.176 18.1-29.673 5.924-58.933-12.086-67.047-41.025-7.364-26.528 4.682-53.691 26.98-66.994 0 0 20.957-10.883 20.716-38.547-.078-.778-.04-1.486-.118-2.264-.022-.095-.044-.19.03-.307-.041-22.427 15.893-43.056 39.242-47.84Z",
    fill: "#141975"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.897,
    cy: 160.106,
    rx: 9.974,
    ry: 10.006,
    fill: "#F9805D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.932,
    cy: 102.571,
    rx: 5.486,
    ry: 5.503,
    fill: "#B746E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ws-illustration_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.84,
    height: 171.304,
    rx: 7.134,
    transform: "rotate(-10.502 189.713 -80.67) skewX(-.065)",
    fill: "#C56BEB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ws-illustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.83,
    height: 171.317,
    rx: 7.134,
    transform: "rotate(5.544 -147.08 571.187) skewX(.035)",
    fill: "#E2B5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ws-illustration_svg__a",
    x: 19.055,
    y: 10.194,
    width: 159.301,
    height: 192.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.378
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_59639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_516_59639",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ws-illustration_svg__b",
    x: 38.7,
    y: 17.537,
    width: 147.353,
    height: 184.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.378
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_59639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_516_59639",
    result: "shape"
  })))));
};
export default SvgWsIllustration;